import script from "./invoice-apply-check.vue?vue&type=script&lang=ts&setup=true"
export * from "./invoice-apply-check.vue?vue&type=script&lang=ts&setup=true"

import "./invoice-apply-check.vue?vue&type=style&index=0&id=2d4d625c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d4d625c"]])

export default __exports__